module.exports = __webpack_public_path__ + "img/index-bg.7ebfb081.jpg";